<template>
  <div id="changeUserInfo">
    <!-- 左侧边栏 -->
    <ul class="changeInfoLeftSideBar">
      <li @click="sidBarSelect('1')" :class="sideBarActive=='1'?'leftSideBarActive':''">
        <img v-if="sideBarActive=='1'" src="../../assets/image/icon_xggr3@2xS.png" alt />
        <img v-else src="../../assets/image/icon_xggr3@2x.png" alt />
        <span>修改个人信息</span>
      </li>
      <li @click="sidBarSelect('2')" :class="sideBarActive=='2'?'leftSideBarActive':''">
        <img v-if="sideBarActive=='2'" src="../../assets/image/icon_zhaq2@2xS.png" alt />
        <img v-else src="../../assets/image/icon_zhaq2@2x.png" alt />
        <span>账号安全/密码</span>
      </li>
      <li @click="sidBarSelect('3')" :class="sideBarActive=='3'?'leftSideBarActive':''">
        <img v-if="sideBarActive=='3'" src="../../assets/image/icom_xgqy2@2xS.png" alt />
        <img v-else src="../../assets/image/icom_xgqy2@2x.png" alt />
        <span>修改企业信息</span>
      </li>
    </ul>
    <!-- 右边主体 -->
    <div class="changeUserInfoBox">
      <!-- !!!修改个人信息 -->
      <div class="formBody" v-if="sideBarActive=='1'">
        <!-- 1.账号名称 -->
        <el-row class="formRow">
          <div class="leftLabel">
            <img src="../../assets/image/icon_zhmc@2x.png" alt />
            <span title="账号名称">账号名称</span>
          </div>
          <div class="rightInput">
            <el-input v-model="editUserForm.nickname"></el-input>
          </div>
        </el-row>
        <!-- 2.头像 -->
        <el-row class="formRow">
          <div class="leftLabel">
            <img src="../../assets/image/icon_tp@2x.png" alt />
            <span title="头像">头像</span>
          </div>
          <div class="rightInput upLoadInput">
            <img
              v-if="!editUserForm.avatar && my_process_avatarUrl"
              :src="my_process_avatarUrl"
              alt
              style="width:75px;height:75px"
            />
            <img
              v-else-if="editUserForm.avatar"
              :src="this.editUserForm.avatar"
              alt
              style="width:75px;height:75px"
            />
            <div class="noPic" v-else>
              <i class="el-icon-plus"></i>
            </div>
            <el-upload class="upload-demo" action="#" :before-upload="handleBefore">
              <el-button size="small" type="primary">
                <img src="../../assets/image/icon_sc@2x.png" alt />
                点击上传文件
              </el-button>
            </el-upload>
          </div>
        </el-row>
        <!-- 3.邮箱 -->
        <el-row class="formRow">
          <div class="leftLabel">
            <img src="../../assets/image/icon_yx@2x.png" alt />
            <span title="邮箱">邮箱</span>
          </div>
          <div class="rightInput">
            <el-input v-model="editUserForm.mail"></el-input>
          </div>
        </el-row>
        <!-- 4.座右铭 -->
        <el-row class="formRow aiTop">
          <div class="leftLabel">
            <img src="../../assets/image/icom_jj@2x.png" alt />
            <span title="座右铭">座右铭</span>
          </div>
          <div class="rightInput">
            <el-input type="textarea" v-model="editUserForm.motto"></el-input>
          </div>
        </el-row>
        <!-- 按钮行 -->
        <el-row class="formRow btnRow">
          <el-col class="leftLable" :span="4"></el-col>
          <el-col class="rightInput" :span="20">
            <el-button type="info" @click="handleCanel">取消</el-button>
            <el-button type="primary" @click="handleEditUserInfo">提交</el-button>
          </el-col>
        </el-row>
      </div>
      <!-- !!!账号安全/密码 -->
      <div class="formBody" v-if="sideBarActive=='2'">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <!-- ???修改账号 -->
          <el-tab-pane label="修改账号" name="username">
            <!-- 1.账号名称 -->
            <el-row class="formRow">
              <div class="leftLabel">
                <img src="../../assets/image/icon_zhmc@2x.png" alt />
                <span title="账号名称">账号名称</span>
              </div>
              <div class="rightInput">
                <el-input disabled v-model="editNikenameForm.username"></el-input>
              </div>
            </el-row>
            <!-- 3.验证码 -->
            <el-row class="formRow">
              <div class="leftLabel">
                <img style="width:19px" src="../../assets/image/icon_yzm2@2x.png" alt />
                <span title="验证码">验证码</span>
              </div>
              <div class="rightInput BtnInput">
                <el-input placeholder="发送到原账号上" v-model="editNikenameForm.code"></el-input>
                <!-- <el-button type="primary">获取验证码</el-button> -->
                <el-button
                  @click="editNicknameGetOldCode"
                  type="primary"
                  :disabled="!BtnStatusOld"
                >{{BtnStatusOld?'获取验证码':`${countDownTimeOld}秒后获取`}}</el-button>
              </div>
            </el-row>
            <!-- 4.新账号 -->
            <el-row class="formRow">
              <div class="leftLabel">
                <img style="width:19px" src="../../assets/image/icon_sjzh@2x.png" alt />
                <span title="新账号">新账号</span>
              </div>
              <div class="rightInput">
                <el-input placeholder="请输入您的新账号" v-model="editNikenameForm.new_username"></el-input>
              </div>
            </el-row>
            <!-- 5.验证码 -->
            <el-row class="formRow">
              <div class="leftLabel">
                <img style="width:19px" src="../../assets/image/icon_yzm2@2x.png" alt />
                <span title="验证码">验证码</span>
              </div>
              <div class="rightInput BtnInput">
                <el-input placeholder="发送到新账号上" v-model="editNikenameForm.new_code"></el-input>
                <!-- <el-button type="primary">获取验证码</el-button> -->
                <el-button
                  @click="editNicknameGetNewCode"
                  type="primary"
                  :disabled="!BtnStatusNew"
                >{{BtnStatusNew?'获取验证码':`${countDownTimeNew}秒后获取`}}</el-button>
              </div>
            </el-row>

            <!-- 按钮行 -->
            <el-row class="formRow btnRow">
              <el-col class="leftLable" :span="4"></el-col>
              <el-col class="rightInput" :span="20">
                <el-button type="info" :disabled="isDisable" @click="handleEditNicknamSubmit">取消</el-button>
                <el-button type="primary" @click="handleEditNicknamSubmit">提交</el-button>
              </el-col>
            </el-row>
          </el-tab-pane>
          <!-- ???修改密码 -->
          <el-tab-pane label="修改密码" name="psd">
            <!-- 1.账号名称 -->
            <el-row class="formRow">
              <div class="leftLabel">
                <img src="../../assets/image/icon_zhmc@2x.png" alt />
                <span title="账号名称">账号名称</span>
              </div>
              <div class="rightInput">
                <el-input disabled v-model="editPsdForm.username"></el-input>
              </div>
            </el-row>
            <!-- 2.新密码 -->
            <el-row class="formRow">
              <div class="leftLabel">
                <img style="width:16px" src="../../assets/image/icon_mima@2x.png" alt />
                <span title="新密码">新密码</span>
              </div>
              <div class="rightInput">
                <el-input type="password" placeholder="请输入您的新密码" v-model="editPsdForm.password"></el-input>
              </div>
            </el-row>
            <!-- 2.确认密码 -->
            <el-row class="formRow">
              <div class="leftLabel">
                <img style="width:16px" src="../../assets/image/icon_mima@2x.png" alt />
                <span title="确认密码">确认密码</span>
              </div>
              <div class="rightInput">
                <el-input type="password" placeholder="请确认您的新密码" v-model="editPsdForm.repassword"></el-input>
              </div>
            </el-row>
            <!-- 4.验证码 -->
            <el-row class="formRow">
              <div class="leftLabel">
                <img style="width:19px" src="../../assets/image/icon_yzm2@2x.png" alt />
                <span title="验证码">验证码</span>
              </div>
              <div class="rightInput BtnInput">
                <el-input placeholder="请输入您的验证码" v-model="editPsdForm.code"></el-input>
                <!-- <el-button type="primary">获取验证码</el-button> -->
                <el-button
                  @click="editNicknameGetOldCode"
                  type="primary"
                  :disabled="!BtnStatusOld"
                >{{BtnStatusOld?'获取验证码':`${countDownTimeOld}秒后获取`}}</el-button>
              </div>
            </el-row>

            <!-- 按钮行 -->
            <el-row class="formRow btnRow">
              <el-col class="leftLable" :span="4"></el-col>
              <el-col class="rightInput" :span="20">
                <el-button type="info" :disabled="isDisable" @click="handleCanel">取消</el-button>
                <el-button type="primary" @click="handleChangePsdSubmit">提交</el-button>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 修改企业信息 -->
      <div class="formBody" v-if="sideBarActive=='3'">
        <!-- 1.企业全称 -->
        <el-row class="formRow">
          <div class="leftLabel leftLabel1">
            <img src="../../assets/image/icon_gs@2x.png" alt />
            <span title="企业全称">企业全称</span>
          </div>
          <div class="rightInput">
            <el-input v-model="editCompanyForm.company_name"></el-input>
          </div>
        </el-row>
        <!-- 是否打开侧重部门 -->
        <el-row class="formRow">
          <div class="leftLabel leftLabel1">
            <img src="../../assets/image/icon_gs@2x.png" alt />
            <span title="是否打开侧重部门">是否打开侧重部门</span>
          </div>
          <div class="rightInput">
            <el-radio-group v-model="editCompanyForm.department_model">
              <el-radio :label="'1'">是</el-radio>
              <el-radio :label="'0'">否</el-radio>
            </el-radio-group>
          </div>
        </el-row>
        <!-- 2.企业logo -->
        <el-row class="formRow">
          <div class="leftLabel leftLabel1">
            <img src="../../assets/image/icon_tp@2x.png" alt />
            <span title="企业logo">企业logo</span>
          </div>
          <div class="rightInput upLoadInput">
            <img
              :src="my_company_logo"
              v-if="!editCompanyForm.company_logo && my_company_logo"
              alt
              style="width:75px;height:75px"
            />
            <img
              :src="editCompanyForm.company_logo"
              v-else-if="editCompanyForm.company_logo"
              alt
              style="width:75px;height:75px"
            />
            <div class="noPic" v-else>
              <i class="el-icon-plus"></i>
            </div>
            <el-upload class="upload-demo" action="#" :before-upload="handleBefore2">
              <el-button size="small" type="primary">
                <img src="../../assets/image/icon_sc@2x.png" alt />
                点击上传文件
              </el-button>
            </el-upload>
          </div>
        </el-row>
        <!-- 4.企业简介 -->
        <el-row class="formRow aiTop">
          <div class="leftLabel leftLabel1">
            <img src="../../assets/image/icom_jj@2x.png" alt />
            <span title="企业简介">企业简介</span>
          </div>
          <div class="rightInput">
            <el-input type="textarea" v-model="editCompanyForm.content"></el-input>
          </div>
        </el-row>
        <!-- 按钮行 -->
        <el-row class="formRow btnRow">
          <el-col class="leftLable" :span="4"></el-col>
          <el-col class="rightInput" :span="20">
            <el-button type="info" :disabled="isDisable" @click="handleCanel">取消</el-button>
            <el-button type="primary" @click="handleChangeCompanySubmit">提交</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      my_company_name: '',
      my_company_logo: '',
      my_process_avatarUrl: '',
      my_company_department_model: '',
      my_nickname: '',
      // 验证码禁用
      BtnStatusOld: true,
      BtnStatusNew: true,
      countDownTimeOld: 60,
      countDownTimeNew: 60,
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      sideBarActive: '1',
      // 修改个人信息
      editUserForm: {
        nickname: '',
        code: '',
        avatar: '',
        mail: '',
        motto: '',
      },
      // 修改账号信息
      editNikenameForm: {
        beforeUsername: '',
        code: '',
        new_username: '',
        new_code: '',
      },
      // 修改密码表单
      editPsdForm: {
        username: '',
        code: '',
        password: '',
        repassword: '',
      },
      editCompanyForm: {
        company_name: '',
        company_logo: '',
        content: '',
        department_model: '0',
      },

      imgUrl: '',
      imgUrl2: '',
      activeName: 'username',
      isDisable: true,
    }
  },
  methods: {
    handleClick(tab, event) {},
    handleCanel() {
      this.$router.go(-1)
    },
    sidBarSelect(val) {
      this.sideBarActive = val
    },
    // *修改企业信息提交
    async handleChangeCompanySubmit() {
      if (this.editCompanyForm.company_name.trim().length <= 0)
        return this.$message.error('请输入企业名称')
      // if (!this.editPsdForm.password) return this.$message.error('请输入新密码')

      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('company_name', this.editCompanyForm.company_name)
      param.append('company_logo', this.editCompanyForm.company_logo)
      param.append('content', this.editCompanyForm.content)
      param.append('department_model', this.editCompanyForm.department_model)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Company/update',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      window.localStorage.setItem(
        'bthl_process_LoginCompanyName',
        this.editCompanyForm.company_name
      )
      window.localStorage.setItem(
        'bthl_process_LoginCompanyLoGo',
        this.editCompanyForm.company_logo
      )
      window.localStorage.setItem(
        'bthl_process_department_model',
        this.editCompanyForm.department_model
      )
      this.my_process_avatarUrl = this.editCompanyForm.company_name
      this.my_nickname = this.editCompanyForm.company_logo
      // this.$router.go(-1)
      this.$router.push({
        path: '/index/home',
        query: {
          department_model: this.editCompanyForm.department_model,
        },
      })
    },
    // *提交密码修改
    async handleChangePsdSubmit() {
      if (this.editPsdForm.code.trim().length <= 0)
        return this.$message.error('请输入验证码')
      if (!this.editPsdForm.password) return this.$message.error('请输入新密码')
      if (!this.editPsdForm.repassword)
        return this.$message.error('请请确认您的新密码')
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('code', this.editPsdForm.code)
      param.append('password', this.editPsdForm.password)
      param.append('repassword', this.editPsdForm.repassword)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/User/update_password',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      this.$router.go(-1)
    },

    // *提交修改账号
    async handleEditNicknamSubmit() {
      if (this.editNikenameForm.new_username.trim().length <= 0)
        return this.$message.error('请输入新账号')
      if (!this.editNikenameForm.code)
        return this.$message.error('请输入旧验证码')
      if (!this.editNikenameForm.new_code)
        return this.$message.error('请输入新验证码')
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('code', this.editNikenameForm.code)
      param.append('new_username', this.editNikenameForm.new_username)
      param.append('new_code', this.editNikenameForm.new_code)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/User/update_username',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      this.$router.go(-1)
    },
    // 修改账号获取验证码-旧手机
    async editNicknameGetOldCode() {
      let param = new URLSearchParams()
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('member_id', this.member_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/User/send_message',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      this.GetCodeOld()
    },
    // 修改账号获取验证码-新手机
    async editNicknameGetNewCode() {
      // 手机号是否为空
      if (this.editNikenameForm.new_username.trim().length == 0) {
        return this.$message.error('请输入新账号')
      }
      // 手机号正则校验
      const reg = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/
      let isPhoneNum = reg.test(this.editNikenameForm.new_username)
      if (!isPhoneNum) {
        return this.$message.error('请输正确入手机号')
      }
      this.GetCodeNew()
      let param = new URLSearchParams()
      param.append('username', this.editNikenameForm.new_username)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Public/send_message',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
    },
    // *提交修改个人信息
    async handleEditUserInfo() {
      if (this.editUserForm.nickname.trim().length <= 0)
        return this.$message.error('请输入昵称')
      // if (!this.editUserForm.avatar) return this.$message.error('请上传头像')
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('nickname', this.editUserForm.nickname)
      param.append('avatar', this.editUserForm.avatar)
      param.append('mail', this.editUserForm.mail)
      param.append('motto', this.editUserForm.motto)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/User/update',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)

      this.$message.success(res.datas.msg)
      window.localStorage.setItem(
        'btlh_process_avatarUrl',
        this.editUserForm.avatar
      )
      window.localStorage.setItem(
        'btlh_process_nickname',
        this.editUserForm.nickname
      )
      this.my_process_avatarUrl = this.editUserForm.avatar
      this.my_nickname = this.editUserForm.nickname
      this.$router.go(-1)
    },
    // 验证码倒计时
    GetCodeOld() {
      let endMsRes = new Date().getTime() + 60000
      localStorage.setItem('GetCodeOld_myEndTime', JSON.stringify(endMsRes))
      this.codeCountDownOld(endMsRes)
    },
    GetCodeNew() {
      console.log('GetCodeNew')
      let endMsRes = new Date().getTime() + 60000
      localStorage.setItem('GetCodeNew_myEndTime', JSON.stringify(endMsRes))
      this.codeCountDownNew(endMsRes)
    },
    codeCountDownOld(endMsRes) {
      this.BtnStatusOld = false
      this.countDownTimeOld = Math.ceil(
        (endMsRes - new Date().getTime()) / 1000
      )
      let time = setTimeout(() => {
        this.countDownTimeOld--
        if (this.countDownTimeOld < 1) {
          this.BtnStatusOld = true
          this.countDownTimeOld = 60
          localStorage.removeItem('GetCodeOld_myEndTime')
          clearTimeout(time)
        } else {
          this.codeCountDownOld(endMsRes)
        }
      }, 1000)
    },
    codeCountDownNew(endMsRes) {
      this.BtnStatusNew = false
      this.countDownTimeNew = Math.ceil(
        (endMsRes - new Date().getTime()) / 1000
      )
      let time = setTimeout(() => {
        this.countDownTimeNew--
        if (this.countDownTimeNew < 1) {
          this.BtnStatusNew = true
          this.countDownTimeNew = 60
          localStorage.removeItem('GetCodeNew_myEndTime')
          clearTimeout(time)
        } else {
          this.codeCountDownNew(endMsRes)
        }
      }, 1000)
    },
    // 上传-企业logo
    async handleBefore2(file) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('file', file)
      const { data: res } = await this.$axios({
        method: 'post',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        url: '/api/User/uploadImg',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success('上传成功')
      this.editCompanyForm.company_logo = res.datas.img_url
      console.log('企业logo', this.editCompanyForm.company_logo)
    },
    // 上传-头像
    async handleBefore(file) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('file', file)
      const { data: res } = await this.$axios({
        method: 'post',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        url: '/api/User/uploadImg',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success('上传成功')
      this.editUserForm.avatar = res.datas.img_url
      console.log('头像', this.editUserForm.avatar)
    },
    getId() {
      this.sideBarActive = this.$route.query.type
    },
  },
  created() {
    if (this.$route.query.type) {
      this.sideBarActive = this.$route.query.type
    }
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''

    this.my_process_avatarUrl =
      localStorage.getItem('btlh_process_avatarUrl') || ''
    this.my_nickname = localStorage.getItem('btlh_process_nickname') || ''
    this.my_company_logo =
      localStorage.getItem('bthl_process_LoginCompanyLoGo') || ''
    this.my_company_name =
      localStorage.getItem('bthl_process_LoginCompanyName') || ''
    this.my_company_department_model =
      localStorage.getItem('bthl_process_department_model') || ''
    if (this.my_nickname) {
      this.editUserForm.nickname = this.my_nickname
      this.editNikenameForm.username = this.my_nickname
      this.editPsdForm.username = this.my_nickname
    }
    if (this.my_company_name) {
      this.editCompanyForm.company_name = this.my_company_name
    }
    if (this.my_company_logo) {
      this.editCompanyForm.company_logo = this.my_company_logo
    }
    if (this.my_company_department_model) {
      this.editCompanyForm.department_model = this.my_company_department_model
    }
    // 获取验证码倒计时
    let myEndTimeNew = localStorage.getItem('GetCodeNew_myEndTime')
    myEndTimeNew && this.codeCountDownNew(myEndTimeNew)
    let myEndTimeOld = localStorage.getItem('GetCodeOld_myEndTime')
    myEndTimeOld && this.codeCountDownOld(myEndTimeOld)
  },
}
</script>
<style lang="less" scoped>
#changeUserInfo {
  width: 100%;
  height: 92%;
  background-color: #f2f3f4;
  display: flex;
  // 左侧边栏
  .changeInfoLeftSideBar {
    height: 100%;
    width: 310px;
    background-color: #fff;
    li {
      cursor: pointer;
      display: flex;
      align-items: center;
      width: 100%;
      height: 95px;
      color: #666666;
      font-size: 18px;
      img {
        width: 22px;
        margin-left: 70px;
        margin-right: 15px;
      }
    }
    .leftSideBarActive {
      background-color: #e4f3ff;
      color: #128bf1;
    }
  }
  // 右主体表单
  .changeUserInfoBox {
    width: calc(100% - 310px);
    height: 100%;
    box-sizing: border-box;
    padding: 30px;
    .formBody {
      border-radius: 10px;
      box-shadow: 1px 5px 9px 0px rgba(3, 70, 126, 0.14);
      width: 100%;
      height: 100%;
      background-color: #fff;
      box-sizing: border-box;
      padding-top: 20px;
      // 表单每一行
      /deep/.formRow {
        margin-top: 40px;
        display: flex;
        align-items: center;
        width: 100%;
        .leftLabel {
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: 16%;
          // font-size: 20px;
          font-size: 18px;
          color: #333333;
          img {
            margin-left: 40%;
            width: 22px;
            margin-right: 10px;
          }
          span {
            width: 50%;
            overflow: hidden; /*超出部分隐藏*/
            white-space: nowrap; /*不换行*/
            text-overflow: ellipsis; /*超出部分文字以...显示*/
          }
        }
        .leftLabel1 {
          width: 30%;
          span {
            // width: 80% !important;
          }
        }
        .rightInput {
          width: 84%;
          .noPic {
            width: 76px;
            height: 76px;
            border-radius: 38px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #eceef0;
            i {
              font-size: 40px;
              color: #fff;
              font-weight: 700;
            }
          }
          .el-input__inner {
            width: 50%;
            border-radius: 0;
            height: 50px;
            font-size: 18px;
          }
          .el-textarea__inner {
            width: 50%;
            height: 250px;
            font-size: 18px;
            resize: none;
            border-radius: 0;
            font-family: Microsoft YaHei;
          }
        }
        // 带按钮的表单修改
        .BtnInput {
          display: flex;
          .el-input {
            width: 35%;
          }
          .el-input__inner {
            width: 100%;
            border-radius: 0;
            height: 50px;
            font-size: 18px;
          }
          .el-button {
            margin-left: 2%;
            padding: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 13%;
            font-size: 16px;
            font-weight: normal;
            border-radius: 0;
            background-color: #40a0f2;
            border-color: #40a0f2;
          }
          .el-button--primary:hover {
            background: #66b1ff;
            border-color: #66b1ff;
            color: #fff;
          }
        }
        .upLoadInput {
          display: flex;
          align-items: flex-end;
          .el-button {
            border: none;
            background-color: #fff;
            color: #128bf1;
            font-size: 16px;
            font-weight: normal;
            img {
              width: 19px;
              height: 14px;
            }
          }
        }
      }
      // textArea 行
      .aiTop {
        align-items: flex-start !important;
        .leftLabel {
          box-sizing: border-box;
          padding-top: 10px;
        }
        /deep/.el-textarea__inner {
          width: 40%;
          height: 250px;
          font-size: 18px;
          resize: none;
          border-radius: 0;
        }
      }
      // 按钮行
      .btnRow {
        .rightInput {
          display: flex;
        }
        /deep/.el-button--info {
          background-color: #cccccc;
          border-color: #ccc;
        }
        /deep/.el-button {
          // width: 160px;
          width: 14%;
          margin-right: 5%;
          height: 50px;
          padding: 0;
          border-radius: 25px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 20px;
          font-weight: normal;
        }
        /deep/ .el-button--primary:hover {
          background: #66b1ff;
          border-color: #66b1ff;
          color: #fff;
        }
      }
      // 修改tabs样式
      /deep/.el-tabs__header {
        box-sizing: border-box;
        padding: 0 40px;
        .el-tabs__item {
          width: 240px;
          padding-left: 30px;
          font-size: 18px;
          color: #666;
        }
        .el-tabs__item:hover {
          color: #333;
        }
        .el-tabs__item.is-active {
          color: #333;
        }
        .el-tabs__active-bar {
          width: 70px !important;
          // margin-left: 30px;
        }
      }
    }
  }
  /deep/.el-radio-group {
    .el-radio__label {
      font-size: 18px;
      font-weight: normal;
      color: #333;
    }
  }
}
</style>